var _excluded = ["children", "onOpenChange", "isOpen", "title", "footer", "size", "dropdownTestId", "maxHeight", "trigger", "isDisabled", "isReadOnly"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useBreakpoint, useBreakpointValue } from '../../theme';
import { forwardRef } from '../../utils';
import { BaseMenu } from '../BaseMenu';
import { BaseMenuContext, useBaseMenu } from '../BaseMenu/hooks';
import { _MenuFooter } from './components/_MenuFooter/_MenuFooter';
import { _MenuTitle } from './components/_MenuTitle/_MenuTitle';
import { _MenuTrigger } from './components/_MenuTrigger';
import { _MobileMenuDropdown } from './components/_MobileMenuDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Menu = forwardRef((_ref, ref) => {
  var {
    children,
    onOpenChange: _onOpenChange,
    isOpen,
    title,
    footer,
    size,
    dropdownTestId,
    maxHeight,
    trigger,
    isDisabled,
    isReadOnly
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var isDropdownOpen = isDisabled || isReadOnly ? false : isOpen;
  var desktopWidth = size === 'small' && '198px' || size === 'large' && '234px' || 'fit-content';
  var width = useBreakpointValue({
    xs: '100vw',
    s: desktopWidth
  });
  var menu = useBaseMenu({
    onOpenChange: isMobileMenuOpen => {
      if (isDisabled || isReadOnly) return;

      if (isMobile) {
        _onOpenChange(isMobileMenuOpen);
      }
    },
    isOpen: isDropdownOpen,
    width
  });
  return isMobile ? /*#__PURE__*/_jsxs(BaseMenuContext.Provider, {
    value: menu,
    children: [/*#__PURE__*/_jsx(_MenuTrigger, _objectSpread(_objectSpread({
      ref: ref
    }, props), {}, {
      trigger: trigger,
      isDisabled: isDisabled
    })), /*#__PURE__*/_jsx(_MobileMenuDropdown, {
      title: title,
      footer: footer,
      size: size,
      dropdownTestId: dropdownTestId,
      children: children
    })]
  }) : /*#__PURE__*/_jsx(BaseMenu, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    trigger: trigger,
    isOpen: !isDisabled && isOpen,
    onOpenChange: _onOpenChange,
    header: title && /*#__PURE__*/_jsx(_MenuTitle, {
      label: title
    }),
    footer: footer && /*#__PURE__*/_jsx(_MenuFooter, _objectSpread({}, footer)),
    width: width,
    maxHeight: maxHeight,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    dropdownTestId: dropdownTestId,
    children: children
  }));
});
Menu.displayName = 'Menu';
//# sourceMappingURL=Menu.js.map